import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const EditFlightBookingModal = ({ bookingDetails, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    pnr: "",
    supplierBookingId: "",
    serviceFee: "",
  });
  const [loading, setLoading] = useState(false);

  // Initialize form with booking details
  useEffect(() => {
    if (bookingDetails) {
      setFormData({
        pnr: bookingDetails.pnr || "",
        supplierBookingId: bookingDetails.supplierBookingId || "",
        serviceFee: bookingDetails.markup?.toString() || "",
      });
    }
  }, [bookingDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const updateData = {
        pnr: formData.pnr,
        supplierBookingId: formData.supplierBookingId,
        serviceFee: parseFloat(formData.serviceFee) || 0,
      };

      await apiService.put(
        `${config.UPDATEFLIGHTBOOKING}/${bookingDetails.flightBookingId}`,
        updateData
      );
      
      onSuccess();
    } catch (error) {
      console.error("Error updating flight booking:", error);
      alert("Error updating flight booking. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-md modal-dialog-centered"style={{ maxWidth: "500px" }}>
        <div className="modal-content">
          <div className="modal-header py-2 px-3">
            <h6 className="modal-title mb-0">
              <i className="ri-edit-box-line me-1"></i> Edit Booking
            </h6>
            <button
              type="button"
              className="btn-close btn-close-sm"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body py-2 px-3">
            <form onSubmit={handleSubmit}>
              <div className="row g-2">
                <div className="col-md-12 mb-2">
                  <label className="form-label small fw-semibold mb-1">PNR</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="pnr"
                    value={formData.pnr}
                    onChange={handleInputChange}
                    placeholder="Enter PNR"
                  />
                </div>
                <div className="col-md-12 mb-2">
                  <label className="form-label small fw-semibold mb-1">Supplier Confirmation</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="supplierBookingId"
                    value={formData.supplierBookingId}
                    onChange={handleInputChange}
                    placeholder="Enter confirmation ID"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label small fw-semibold mb-1">Service Fee (Markup)</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    name="serviceFee"
                    value={formData.serviceFee}
                    onChange={handleInputChange}
                    placeholder="0.00"
                  />
                </div>
              </div>
              <div className="modal-footer p-2 mt-3">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Updating...
                    </>
                  ) : (
                    <>
                      <i className="ri-save-line me-1"></i> Update
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFlightBookingModal;